import { render, staticRenderFns } from "./CardHoliday.vue?vue&type=template&id=c687b1fe&"
import script from "./CardHoliday.vue?vue&type=script&lang=js&"
export * from "./CardHoliday.vue?vue&type=script&lang=js&"
import style0 from "./CardHoliday.vue?vue&type=style&index=0&id=c687b1fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports